import { DtoCodigoDescripcion } from "../../../../shared/Domain/Dto/DtoCodigoDescripcion";

export class DtoTipoMaterial extends DtoCodigoDescripcion {
}